import React, { useState, useEffect } from 'react';
import styles from '../layout.module.less';
import ListTemplate from './ListTemplate';
import { Pagination,Button } from 'antd';

import {observer} from "mobx-react";
import store from '../store';
import { useHistory } from 'react-router-dom';
import{addVisitLog} from 'libs';
import gStore from 'store';
import FormRow from "./FormRow";


const Home = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const params1 = searchParams.get('params1');
  const params2 = searchParams.get('params2');
  // 当前选中的一级分类 value
  const [firstActive, setFirstActive] = useState(params1);
  // 当前选中的二级分类 value
  const [secondActive, setSecondActive] = useState(params2);
   // 一级分类加“全部”
  const [firstCategories, setFirstCategories] = useState([]);
  // 当前二级分类列表
  const [secondCategories, setSecondCategories] = useState([]);
  store.mallCategoryOne = params1||firstActive;
  store.mallCategoryTwo = params2||secondActive;
  const history = useHistory();

  useEffect(() => {
    store.fetchRecords();
    store.fetchMallCategoryList();
  }, []);
  useEffect(() => {
    setFirstActive(store.mallCategoryOne);
    setSecondActive(store.mallCategoryTwo);
  }, [store.mallCategoryOne,store.mallCategoryTwo]);
  useEffect(() => {
    if(store.mallCategoryList.length > 0){
      setFirstCategories([ ...store.mallCategoryList]);
    //  const allChildren = store.mallCategoryList.flatMap(item =>
    //     (item.children || []).map(child => ({
    //       ...child,
    //       parentValue: item.value, // 记录一级分类的 value
    //     }))
    //   );
      // setSecondCategories([...allChildren]);
    }
  }, [store.mallCategoryList]);
  useEffect(() => {
    let allChildren = [];
    if(store.mallCategoryOne){
      allChildren = store.mallCategoryList.filter(item =>
        item.value === store.mallCategoryOne
      ).flatMap(item =>
        (item.children || []).map(child => ({
          ...child,
          parentValue: item.value, // 记录一级分类的 value
        }))
      );
      allChildren = [{label:'所有产品',value:null},...allChildren]
    }else{
      allChildren = store.mallCategoryList.flatMap(item =>
        (item.children || []).map(child => ({
          ...child,
          parentValue: item.value, // 记录一级分类的 value
        }))
      );
    }
    setTimeout(() => {
      setSecondCategories([...allChildren]);
    }, 0);
  }, [store.mallCategoryOne,store.mallCategoryList]);
     //点击一级品类
  const handleChangeFirstActive = (value) => {
    store.mallCategoryOne = value;
    store.mallCategoryTwoName = '所有产品';
    store.mallCategoryTwo = null;
    setSecondActive(null);
    setFirstActive(value)
    store.page = 1;
    store.pageTotal = 0;
    addVisitLog({
      pageName: '产品页分类',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ProductMallCategory",
      eventName: "产品页分类",
      content: JSON.stringify({mallCategoryOne:value}),
    })
    store.fetchRecords();
    history.push(`/goods`);
  }
  //点击二级品类
  const handleChangeMallCategory = (item) => {
    store.mallCategoryOne = item.parentValue;
    store.mallCategoryTwoName = item.label;
    store.mallCategoryTwo = item.value;
    setSecondActive(item.value);
    setFirstActive(item.parentValue)
    store.page = 1;
    store.pageTotal = 0;
    addVisitLog({
      pageName: '产品页分类',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ProductMallCategory",
      eventName: "产品页分类",
      content: JSON.stringify({mallCategoryOne:item.parentValue,mallCategoryTwo:item.value}),
    })
    store.fetchRecords();
    history.push(`/goods`);
  }
  
  return (
    <div className={styles['product-page']}>
      <div className={styles['main-content-area']}>
      {/* 顶部分类 */}
      <div className={styles['category-bar']}>
        <div className={styles['category-group']}>
          <div className={styles['category-group-name']}>全部结果</div>
          <div className={styles['category-group-values']}>
          </div>
        </div>
        <div className={styles['category-group']}>
          <div className={styles['category-group-name']}> 一级分类：</div>
          <div className={styles['category-group-values']}>
            {firstCategories.map(cat => (
              <span
                key={cat.value}
                className={[
                  styles['default-tag'],
                  firstActive == cat.value ? styles['active-tag'] : ''
                ].join(' ')}
                onClick={() => handleChangeFirstActive(cat.value)}
              >
                {cat.label}
              </span>
              
            ))}
          </div>
        </div>
        <div className={styles['category-group']}>
          <div className={styles['category-group-name']}> 二级分类：</div>
          <div className={styles['category-group-values']}>
            {secondCategories.map(cat => (
              <span
                key={cat.value}
                className={[
                  styles['default-tag'],
                  secondActive == cat.value ? styles['active-tag'] : ''
                ].join(' ')}
                onClick={() => handleChangeMallCategory(cat)}
              >
                {cat.label}
              </span>
              
            ))}
          </div>
        </div>
      </div>
      {/* 商品列表 */}
      <div className={styles['product-list']}>
        <ListTemplate skuList={store.records} />
         {
            store.records.length === 0 ? null : (
              <div style={{display:'flex', justifyContent:'flex-end', margin: '40px auto 0', paddingBottom:'48px', textAlign: 'center'}}>
                <Pagination
                  current={store.page}
                  pageSize={store.pageSize}
                  total={store.pageTotal}
                  showTotal={total => `共 ${total} 条`}
                  showSizeChanger={false}
                  showQuickJumper={true} 
                  onChange={store.pageChange}
                  />
              </div>
            )
          }
      </div>
      <FormRow/>
        <div className={styles.submitBtnContainer}>
          <Button type="primary" ghost onClick={store.postInquiry}>
            确定
          </Button>
        </div>
      </div>
    </div>
  );
};

export default observer(Home);